import { SelectBtn } from './SelectBtn';
import { SelectInput } from './SelectInput';

interface Store {
  config: any;
  state: {
    start: string;
    end: string;
  };
}

export class SelectBundler {
  private node: HTMLElement;
  private store: Store;
  private type: 'start' | 'end';
  private btns: SelectBtn[] = [];
  private input: SelectInput;
  private freeInputRadio: HTMLInputElement | null;
  private btnsActiveClassName: string;
  private inputActiveClassName: string;

  constructor({
    node,
    store,
    type,
  }: {
    node: HTMLElement;
    store: Store;
    type: 'start' | 'end';
  }) {
    this.node = node;
    this.store = store;
    this.type = type;

    // 任意の入力ラジオボタン
    this.freeInputRadio = this.node.querySelector('input[type="radio"][data-free-input="true"]');

    this.node.querySelectorAll(this.store.config.selectorName.btn).forEach((btnNode) => {
      this.btns.push(
        new SelectBtn({
          node: btnNode as HTMLInputElement,
          store: this.store,
          type: this.type,
          inactiveSelectNodes: this.inactiveSelectNodes.bind(this),
          resetInputNodes: this.resetInputNodes.bind(this),
        })
      );
    });

    this.input = new SelectInput({
      node: this.node.querySelector(this.store.config.selectorName.input) as HTMLInputElement,
      store: this.store,
      type: this.type,
      inactiveSelectNodes: this.inactiveSelectNodes.bind(this),
      freeInputRadio: this.freeInputRadio,
    });

    this.btnsActiveClassName = this.store.config.className.activeSelectBtn;
    this.inputActiveClassName = this.store.config.className.activeSelectInput;
  }

  inactiveSelectNodes() {
    this.btns.forEach((btn) => btn.node.classList.remove(this.btnsActiveClassName));
    this.input.node.classList.remove(this.inputActiveClassName);
  }

  resetInputNodes() {
    this.input.node.value = '';
  }
}
